import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { Commodity } from "../models/Commodity";

export const getCommodities = async (
  OnlyEnabled?: boolean | null,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "OnlyEnabled", value: OnlyEnabled ?? true },
  ];
  return await apiService.callV2(
    "[SCRAP].[GetCommodities]",
    parameters,
    signal,
  );
};

export const upsertCommodity = async (commodity: Commodity) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    {
      name: "CommodityId",
      value: commodity.IsDuplicate ? null : commodity.CommodityId,
    },
    { name: "CommodityName", value: commodity.CommodityName },
    { name: "CommodityColor", value: commodity.CommodityColor },
    { name: "Author", value: commodity.Author ?? null },
    { name: "Comments", value: commodity.Comments ?? null },
    { name: "IsEnable", value: commodity.IsEnable },
    { name: "IsActive", value: commodity.IsActive },
    { name: "CommodityTypeId", value: commodity.CommodityTypeId },
  ];
  return await apiService.callV2("[SCRAP].[UpsertCommodity]", parameters);
};

export const deleteCommodity = async (CommodityId: number | null) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityId", value: CommodityId },
  ];
  return await apiService.callV2("[SCRAP].[DeleteCommodity]", parameters);
};

export const getCommoditySubstitutes = async (
  commodityId?: number | null,
  onlyEnabled?: boolean,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityId", value: commodityId ?? null },
    { name: "OnlyEnabled", value: onlyEnabled ?? true },
  ];
  return await apiService.callV2(
    "[SCRAP].[GetCommoditySubstitutes]",
    parameters,
    signal,
  );
};

export const upsertCommoditySubstitutes = async (
  commodityId: number,
  substituteCommodityIds: number[],
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityId", value: commodityId },
    {
      name: "SubstituteCommodityIds",
      value: substituteCommodityIds.join(","),
    },
  ];
  return await apiService.callV2(
    "[SCRAP].[UpsertCommoditySubstitutes]",
    parameters,
  );
};

export const getAvailableCommoditiesForSwitch = async (
  commodityId?: number | null,
  signal?: AbortSignal,
) => {
  const apiService = new MESApiService();
  const parameters: spParameter[] = [
    { name: "CommodityId", value: commodityId ?? null },
  ];
  return await apiService.callV2(
    "[SCRAP].[GetAvailableCommoditiesForSwitch]",
    parameters,
    signal,
  );
};
